module.exports = __webpack_public_path__ + "mu.svg?fcbb9709a43b6b1f0b94cb5ae9db08be";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mu.svg
// module id = 1517
// module chunks = 0